module.exports = __webpack_public_path__ + "resources/img/img_secure_center01.2b5d1e8ac68899b5420f485a7260afa6.png";